// extracted by mini-css-extract-plugin
export default {"tagsInputContainer":"styles_tagsInputContainer__2RZki"};